import { render, staticRenderFns } from "./DuplicateMenusModal.vue?vue&type=template&id=c843628a"
import script from "./DuplicateMenusModal.vue?vue&type=script&lang=ts"
export * from "./DuplicateMenusModal.vue?vue&type=script&lang=ts"
import style0 from "./DuplicateMenusModal.vue?vue&type=style&index=0&id=c843628a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports